import { IconProps } from "./IconProps";

const DownloadIcon: React.FC<IconProps> = ({
  width = 24,
  height = 24,
  color = "#FFFFFF",
}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 25 24" fill="none">
      <path
        d="M12.2158 16L7.21582 11L8.61582 9.55L11.2158 12.15V4H13.2158V12.15L15.8158 9.55L17.2158 11L12.2158 16ZM6.21582 20C5.66582 20 5.19499 19.8042 4.80332 19.4125C4.41165 19.0208 4.21582 18.55 4.21582 18V15H6.21582V18H18.2158V15H20.2158V18C20.2158 18.55 20.02 19.0208 19.6283 19.4125C19.2367 19.8042 18.7658 20 18.2158 20H6.21582Z"
        fill={color}
      />
    </svg>
  );
};
export default DownloadIcon;
